/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../_chunks/dep-56ceb7ce.mjs';
import { _ as _defineProperty } from '../../_chunks/dep-b011b919.mjs';
import { defineComponent, ref, computed, createVNode } from 'vue';
import { DeleteIcon, AddIcon } from 'tdesign-icons-vue-next';
import '../utils/index.mjs';
import { useBaseClassName } from '../hooks.mjs';
import { useCommonClassName } from '../../hooks/useConfig.mjs';
import { useGlobalIcon } from '../../hooks/useGlobalIcon.mjs';
import baseProps from './base-props.mjs';
import { Color } from '../../_common/js/color-picker/color.mjs';
import '../../_chunks/dep-2a2a0e63.mjs';
import '../../_chunks/dep-ae1abe1d.mjs';
import '../../_common/js/color-picker/index.mjs';
import '../../_common/js/color-picker/cmyk.mjs';
import '../../_common/js/color-picker/draggable.mjs';
import '../../_chunks/dep-d8a84e5f.mjs';
import '../../_chunks/dep-5db111ef.mjs';
import '../../_chunks/dep-7f2f03b4.mjs';
import '../../_chunks/dep-eba62589.mjs';
import '../../_chunks/dep-7d9e11c8.mjs';
import '../../_chunks/dep-b9567f6a.mjs';
import '../../_chunks/dep-654b4b01.mjs';
import '../../_chunks/dep-a6022780.mjs';
import '../../_chunks/dep-e00db566.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-8d19eb1a.mjs';
import '../../_chunks/dep-16e2f1a5.mjs';
import '../../_chunks/dep-adebe2ce.mjs';
import '../../_chunks/dep-bd3d75f1.mjs';
import '../../_chunks/dep-2b8d75e2.mjs';
import '../../_chunks/dep-8f44163a.mjs';
import '../../_chunks/dep-a255de71.mjs';
import '../../_chunks/dep-ebe8bc2f.mjs';
import '../../_chunks/dep-cc371884.mjs';
import '../../_chunks/dep-1f0070bb.mjs';
import '../../_chunks/dep-9d0d32fd.mjs';
import '../../_chunks/dep-ebfafd52.mjs';
import '../../_chunks/dep-a11a63ea.mjs';
import '../../_chunks/dep-750294df.mjs';
import '../../_chunks/dep-ad1accf9.mjs';
import '../../_chunks/dep-e05e20e6.mjs';
import '../../_chunks/dep-3e3494dc.mjs';
import '../../_chunks/dep-42be3824.mjs';
import '../../_chunks/dep-67dfe9c7.mjs';
import '../../_chunks/dep-a0bd2e3a.mjs';
import '../../_chunks/dep-91208ac3.mjs';
import '../../_chunks/dep-1041f7d7.mjs';
import '../../_chunks/dep-b32fb318.mjs';
import '../../_chunks/dep-9b57842b.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-99a0abba.mjs';
import '../../_chunks/dep-9d5ee0e1.mjs';
import '../../config-provider/type.mjs';
import '../../_chunks/dep-fc63c737.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SwatchesPanel = defineComponent({
  name: "SwatchesPanel",
  props: _objectSpread(_objectSpread({}, baseProps), {}, {
    colors: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    title: {
      type: String,
      "default": "\u7CFB\u7EDF\u8272\u5F69"
    },
    editable: {
      type: Boolean,
      "default": false
    },
    onSetColor: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    },
    handleAddColor: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    }
  }),
  setup: function setup(props) {
    var baseClassName = useBaseClassName();
    var _useGlobalIcon = useGlobalIcon({
        DeleteIcon: DeleteIcon,
        AddIcon: AddIcon
      }),
      DeleteIcon$1 = _useGlobalIcon.DeleteIcon,
      AddIcon$1 = _useGlobalIcon.AddIcon;
    var _useCommonClassName = useCommonClassName(),
      STATUS = _useCommonClassName.STATUS;
    var statusClassNames = STATUS.value;
    var visiblePopConfirm = ref(false);
    var setVisiblePopConfirm = function setVisiblePopConfirm(visible) {
      visiblePopConfirm.value = visible;
    };
    var handleClick = function handleClick(color) {
      return props.onSetColor(color);
    };
    var isEqualCurrentColor = function isEqualCurrentColor(color) {
      return Color.compare(color, props.color.css);
    };
    var selectedColorIndex = computed(function () {
      return props.colors.findIndex(function (color) {
        return isEqualCurrentColor(color);
      });
    });
    var handleRemoveColor = function handleRemoveColor() {
      var colors = _toConsumableArray(props.colors);
      var selectedIndex = selectedColorIndex.value;
      if (selectedIndex > -1) {
        colors.splice(selectedIndex, 1);
      } else {
        colors.length = 0;
      }
      props.onChange(colors);
      setVisiblePopConfirm(false);
    };
    return {
      baseClassName: baseClassName,
      DeleteIcon: DeleteIcon$1,
      AddIcon: AddIcon$1,
      statusClassNames: statusClassNames,
      selectedColorIndex: selectedColorIndex,
      visiblePopConfirm: visiblePopConfirm,
      setVisiblePopConfirm: setVisiblePopConfirm,
      handleClick: handleClick,
      isEqualCurrentColor: isEqualCurrentColor,
      handleRemoveColor: handleRemoveColor
    };
  },
  render: function render() {
    var _this = this;
    var baseClassName = this.baseClassName,
      DeleteIcon = this.DeleteIcon,
      AddIcon = this.AddIcon,
      statusClassNames = this.statusClassNames,
      title = this.title,
      editable = this.editable;
    var swatchesClass = "".concat(baseClassName, "__swatches");
    var renderActions = function renderActions() {
      if (!editable) {
        return null;
      }
      return createVNode("div", {
        "class": "".concat(swatchesClass, "--actions")
      }, [createVNode("span", {
        "role": "button",
        "class": "".concat(baseClassName, "__icon"),
        "onClick": function onClick() {
          return _this.handleAddColor();
        }
      }, [createVNode(AddIcon, null, null)]), _this.colors.length > 0 ? createVNode("span", {
        "role": "button",
        "class": "".concat(baseClassName, "__icon"),
        "onClick": function onClick() {
          return _this.handleRemoveColor();
        }
      }, [createVNode(DeleteIcon, null, null)]) : null]);
    };
    return createVNode("div", {
      "class": swatchesClass
    }, [createVNode("h3", {
      "class": "".concat(swatchesClass, "--title")
    }, [createVNode("span", null, [title]), renderActions()]), createVNode("ul", {
      "class": ["".concat(swatchesClass, "--items"), "narrow-scrollbar"]
    }, [this.colors.map(function (color) {
      return createVNode("li", {
        "class": ["".concat(swatchesClass, "--item"), _this.isEqualCurrentColor(color) && editable ? statusClassNames.active : ""],
        "title": color,
        "key": color,
        "onClick": function onClick() {
          if (_this.disabled) {
            return;
          }
          _this.handleClick(color);
        }
      }, [createVNode("div", {
        "class": ["".concat(swatchesClass, "--color"), "".concat(baseClassName, "--bg-alpha")]
      }, [createVNode("span", {
        "class": "".concat(swatchesClass, "--inner"),
        "style": {
          background: color
        }
      }, null)])]);
    })])]);
  }
});

export { SwatchesPanel as default };
//# sourceMappingURL=swatches.mjs.map
